import { useMemo } from 'react';
import { Stack, Tab, Tabs } from '@mui/material';
import { useAtomValue } from 'jotai';
import { NavLink, useLocation } from 'react-router';
import { kpiUnassignedCompaniesListStateJ } from '../../../../services/state/KPI/KPICompaniesStateJ';
import { clientConfigFieldsAtom } from '../../../../services/state/AppConfigStateJ';
import { CountBadge, KPITabSx } from '../KPIRequests/TabComponents';
import { ROUTES, getRouteTitle } from '../../../../constants/RouteNameMapping';
import { KPIAssignRequestModal } from './components/KPIAssignRequestModal/KPIAssignRequestModal';

export function KPICompaniesTabs() {
  const { pathname } = useLocation();
  const unassignedPortfolioCompanies = useAtomValue(kpiUnassignedCompaniesListStateJ);
  const isConsolidated = useAtomValue(clientConfigFieldsAtom)?.Using_Consolidated_Data_Collection ?? false;

  const badgeContent = isConsolidated ? undefined : unassignedPortfolioCompanies?.length;

  const tabs = useMemo(() => {
    const allCompaniesPath = `/${ROUTES.KPI}/${ROUTES.COMPANIES}`;
    return [
      {
        path: allCompaniesPath,
        title: (
          <Stack direction='row'>
            {'All Companies'}
            <CountBadge badgeContent={badgeContent} active={pathname === allCompaniesPath} />
          </Stack>
        ),
      },
      {
        path: `/${ROUTES.KPI}/${ROUTES.COMPANIES}/${ROUTES.ASSIGNED_COMPANIES}`,
        title: getRouteTitle(ROUTES.ASSIGNED_COMPANIES),
      },
    ];
  }, [badgeContent, pathname]);

  return (
    <>
      <KPIAssignRequestModal />
      <Tabs variant='scrollable' scrollButtons='auto' value={pathname}>
        {tabs.map((t) => (
          <Tab
            component={NavLink}
            key={t.path}
            value={t.path}
            label={t.title}
            sx={KPITabSx}
            to={{ pathname: `${t.path}` }}
          />
        ))}
      </Tabs>
    </>
  );
}
